import * as React from "react";
import MuiTextField from "@material-ui/core/TextField";
import type { UiBaseProps } from "../uiProps.utils";

export enum TextFieldVariant {
  OUTLINED = "outlined",
  FILLED = "filled",
  STANDARD = "standard",
}

// Which on-screen keyboard a phone shows.
export enum InputMode {
  TEXT = "text",
  NUMERIC = "numeric",
  DECIMAL = "decimal",
}

export type TextFieldProps = UiBaseProps & {
  label?: React.ReactNode;
  value?: string | number;
  onChange?: (value: string) => void;
  variant?: TextFieldVariant;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  inputMode?: InputMode;
  // Keep the label above the field even while it is empty.
  shrinkLabel?: boolean;
  // A dropdown: children are SelectOption items, or <option> elements with `nativeSelect`.
  select?: boolean;
  // The phone's own picker instead of a drawn menu.
  nativeSelect?: boolean;
};

export const TextField: React.FC<TextFieldProps> = ({
  onChange,
  variant = TextFieldVariant.OUTLINED,
  inputMode,
  shrinkLabel,
  nativeSelect,
  ...rest
}) => (
  <MuiTextField
    variant={variant as any}
    onChange={onChange ? (event) => onChange(event.target.value) : undefined}
    inputProps={inputMode ? { inputMode } : undefined}
    InputLabelProps={shrinkLabel ? { shrink: true } : undefined}
    SelectProps={nativeSelect ? { native: true } : undefined}
    {...rest}
  />
);
